export default __webpack_public_path__ + "static/media/bg-blue.67b96567.png";